import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Globals } from '../_globals/globals';
import { AuthenticationService } from '../_services/Authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

    urlPermisionList: any;
    private readonly manufacturerPermission = 'Manufacturer';
    private readonly manufacturerAllowedRoutes = [
        '/main',
        '/help',
        '/master',
        // Ruta técnica del visor usada al generar los planos PDF. No habilita
        // la sección Documentos en el menú del perfil Manufacturer.
        '/document',
        '/file-list',
        '/file-edit',
        '/opti_list',
        '/opti_edit',
        '/parameter',
        '/parameter-edit',
        '/cutting_table',
        '/cutting_table-edit',
        '/bending_machine',
        '/label_editor',
        '/easel',
        '/easel-edit',
        '/workstep',
        '/workstep-edit',
        '/reason',
        '/reason-edit'
    ];

    constructor(
        private router: Router,
        private globals: Globals,
        private authenticationService: AuthenticationService
    ) {
        // Se obtiene el listado de autorizaciones de cada perfil vigente.
        this.urlPermisionList = this.globals.urlPermisionList;
     }

    // Función que comprueba si una sección, cuyo nombre es pasado como parámetro, es visible o no al usuario actual.
    checkPermision(sectionIn: string, permissionIn: string): boolean {
        // console.log(' --> AuthGuard checkPermision comprobar: ' + sectionIn + ' ;perfil: ' + permissionIn);

        // console.log('-->--> -< Permisos globales de las secciones:');
        // console.log(this.sectionPermisionList);
        // console.log(this.sectionPermisionList[sectionIn]);

        if (this.urlPermisionList[sectionIn] && this.urlPermisionList[sectionIn].indexOf(permissionIn) >= 0) {
            console.log('-->--> -< Perfil autorizado.');
            return true;
        } else {
            console.log('-->--> -< Perfil NO autorizado.');
            return false;
        }
    } // End function checkPermision

    private manufacturerCanAccess(urlIn: string): boolean {
        const cleanUrl = (urlIn || '').split('?')[0].split('#')[0];
        return this.manufacturerAllowedRoutes.some(routeIn =>
            cleanUrl === routeIn || cleanUrl.indexOf(routeIn + '/') === 0
        );
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // console.log('--> ** -<> AuthGuard canActivate state.url:');
        // console.log(state.url);

        let permission = false;
        let current_user_id = -1;
        let current_user_permission = 'guest';

        const currentUser = this.authenticationService.currentUserValue;

        // console.log('--> ** -<> AuthGuard currentUser:');
        // console.log(currentUser);

        if (currentUser && !this.authenticationService.isSessionValid(currentUser)) {
            this.authenticationService.redirectToLoginForExpiredSession();
            return false;
        }

        if (currentUser) {

            current_user_id = Number(currentUser.user_id.toString());
            current_user_permission = currentUser.permissions;

            // Manufacturer funciona como lista blanca: aunque una ruta antigua no
            // estuviese incluida en el switch inferior, no se permite por defecto.
            if (current_user_permission === this.manufacturerPermission) {
                if (this.manufacturerCanAccess(state.url)) {
                    return true;
                }
                console.log('--> AuthGuard Manufacturer: acceso denegado a ' + state.url);
                this.router.navigate(['/main']);
                return false;
            }

            // console.log('--> ** -<> AuthGuard canActivate currentUser = ' + current_user_id);
            // console.log(currentUser);
            // console.log('--> ** -<> AuthGuard canActivate user permission = ' + current_user_permission);

            if (current_user_id > -1) {

                // NOTA: Soluciones
                // ---------------------
                // A) Se obtiene de la base de datos todas las "url" a las que tiene acceso el usuario con sus permisos.
                // Se coge entonces la url acutal, y si coincide con alguna a las que tiene permiso entonces podrá entrar.

                // B) Se busca en la base de datos la "url" de entrada y se obtiene su lista de "roles/permisos" que pueden acceder.
                // Si el "rol/permiso" del usuario actual está contenido dentro de la lista entonces podrá entrar a la sección.

                // C) Inicialmente se está haciendo directamente en código al ser pocos perfiles los que existen.
                // Se usan variables globales para guardar la información de todos los permisos de los diferentes perfiles.
                // Aquí se hará un switch donde se listarán todas las secciones
                // en las que queramos que exista algún tipo de control de permisos de acceso.
                switch (state.url) {
                    case '/admin': case '/document':
                    case '/master': case '/main':
                    case '/auto-opti-lote':
                    case '/customers': case '/customers-edit':
                    case '/agent': case '/agent-edit':
                    case '/easel': case '/easel-edit':
                    case '/tracking': case '/tracking-edit':
                    case '/parameter': case '/parameter-edit':
                    case '/file-list': case '/file-edit':
                    case '/cutting_table': case '/cutting_table-edit':
                    case '/reason': case '/reason-edit':

                        // console.log('--> ** -<> AuthGuard url necesita comprobación de permisos para acceso: ' + state.url);

                        // NOTA: Aquí hay que obtener los "permisos" del grupo (los nombres de las secciones
                        // de la aplicación a las cuales podrá acceder) al que pertenece el usuario
                        // y comprobar que la url coincide con alguno de ellos.
                        if (this.checkPermision(state.url, current_user_permission)
                            // NOTA: Si se quisiera dar también acceso exclusivo a algunos usuarios concretos.
                            // && (current_user_id === 0 ||
                            //     current_user_id === 1 ||
                            //     current_user_id === 900)
                        ) {
                            permission = true;
                        }
                        break;

                    default:
                        // console.log('--> ** -<> AuthGuard NO hace falta comprobación de permisos para esta url.' + state.url);
                        permission = true;
                }
            }

            // console.log('--> ** -<> AuthGuard permission = ' + permission);

            if (permission) {
                // Existe usuario y además tiene permisos de acceso.
                return true;
            }
        }

        console.log('--> * AuthGuard canActivate va a redireccionar a la página de Login.');

        // NOTA: Si queremos que cuando se vuelva a loguear le lleve a la página donde estaba.
        // not logged in so redirect to login page with the return url
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });

        return false;
    }
}
